import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  status: string;
  reviewComment?: string;
  expanded: boolean;
  onToggle: () => void;
};

export function profileVerificationTitleKey(status: string): string {
  const title = status === "verified" ? "verifiedTitle" : status === "pending" ? "pendingTitle" : status === "rejected" ? "rejectedTitle" : "notSubmittedTitle";
  return `personalData.accountVerification.${title}`;
}

/** A rejection is a visible decision with a retry, not an unsubmitted request. */
export default function ProfileVerificationSummary({ status, reviewComment, expanded, onToggle }: Props) {
  const { t } = useTranslation();
  const verified = status === "verified";
  const rejected = status === "rejected";
  return <>
    <div className="pd-account-verification-card__header">
      <span aria-hidden="true" className={`pd-account-verification-card__icon ${verified ? "is-verified" : "is-muted"}`}>{rejected ? "!" : "✓"}</span>
      <div>
        <strong role="status">{t(profileVerificationTitleKey(status))}</strong>
        <p>{t(verified ? "personalData.accountVerification.verifiedDescription" : "personalData.accountVerification.description")}</p>
      </div>
    </div>
    {rejected && <div className="pd-account-verification-validation" role="alert">
      {reviewComment && <p className="pd-verification-review-comment">{reviewComment}</p>}
      <p>{t("personalData.ui.errorState")}</p>
    </div>}
    {!verified && <button type="button" className="pd-secondary-button pd-account-verification-card__toggle"
      onClick={onToggle} aria-expanded={expanded}>
      {t(expanded ? "personalData.accountVerification.hideForm" : rejected ? "personalData.accountVerification.retry" : "personalData.accountVerification.getStatus")}
    </button>}
  </>;
}
